<div
  gaCategory="View Media Bar"
  class="view-media-bar"
  *ngIf="showBar">
  
  <!-- Play / Pause -->
  <button 
    gaEvent
    gaAction="Clicked Toggle Animation"
    [gaLabel]="(animationPlaying$ | async) ? 'Pause' : 'Play'"
    app-pin-button
    buttonType="ghost"
    data-test="Play/Pause__small"
    *ngIf="showPlayPause"
    matTooltipPosition="above"
    [matTooltip]="(animationPlaying$ | async) ? 'Pause' : 'Play'"
    (click)="handlePlayClick()"
    [icon]="(animationPlaying$ | async) ? 'pause' : 'play'">
  </button>

  <!-- Play Chapter from Start -->
  <button 
    gaEvent
    gaAction="Clicked Play Chapter From Start"
    app-pin-button
    buttonType="ghost"
    *ngIf="showPlayPause"
    matTooltipPosition="above"
    matTooltip="Play Chapter from Start"
    (click)="handlePlayChapterFromStartClick()"
    icon="step-backward">
  </button>

  <!-- Scrubber -->
  <app-view-scrubber
    *ngIf="showScrubber"
    class="view-media-bar__scrubber"
    data-test="Scrub__small">
  </app-view-scrubber>

  <!-- Play Chapter from Start -->
  <button 
    app-pin-button
    buttonType="ghost"
    matTooltipPosition="above"
    matTooltip="Playback Speed"
    [matMenuTriggerFor]="playbackMenu">
    <span class="text-semibold">{{ playbackSpeed$ | async }}x</span>
  </button>  

  <!-- Audio -->
  <button 
    gaEvent
    gaAction="Clicked Toggle Audio"
    [gaLabel]="(playAudio$ | async) ? 'Mute' : 'Play'"
    *ngIf="audioVisible"
    (click)="handleAudioClick()"
    [icon]="(playAudio$ | async) ? 'volume' : 'volume-slash'"
    [matTooltip]="(playAudio$ | async) ? 'Mute Audio' : 'Play Audio'"
    app-pin-button
    buttonType="ghost"
    class="view-tools__item"
  ></button>

</div>

<mat-menu #playbackMenu="matMenu">
  <button mat-menu-item (click)="setPlaybackSpeed(1)">Normal</button>
  <button mat-menu-item (click)="setPlaybackSpeed(0.5)">0.5</button>
  <button mat-menu-item (click)="setPlaybackSpeed(0.25)">0.25</button>
  <button mat-menu-item (click)="setPlaybackSpeed(0.1)">0.1</button>
</mat-menu>